export default "__VITE_ASSET__DTPWPzuu__"